import { updateFileUploadProgress } from '../actions/files'

import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'
import { simulateFileUploadProgress } from '../../helpers/reducerHelpers'

import { ENDPOINT_PLATFORM, ENDPOINTS } from '../../constants/api'
import { CreateAssetPayload } from '../types/assets'

// PLOP_APPEND_PATTERN_ANCHOR
export async function createAssetService(assetData: CreateAssetPayload['assetData'], platform: string) {
  let progressInterval: NodeJS.Timeout | null = null

  return madeRequest('POST', {
    data: assetData,
    url: replaceRouteParams(ENDPOINTS.assets, {
      platform: ENDPOINT_PLATFORM[platform]
    }),
    // simulate file upload progress:
    onUploadProgress: () => (progressInterval = simulateFileUploadProgress(assetData.name, 500)),
    onDownloadProgress: () => {
      if (progressInterval) {
        clearInterval(progressInterval)
        updateFileUploadProgress({ [assetData.name]: 99 })
      }
    }
  })
}

export async function getAssetsService(params: object, platform: string) {
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.assets, { platform: ENDPOINT_PLATFORM[platform] })
  })
}

export async function createAssetsBatchService(assetsData: object, platform: string) {
  return madeRequest('POST', {
    data: assetsData,
    url: replaceRouteParams(ENDPOINTS.assetsBatch, {
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export async function createAssetGroupService(adData: object, platform: string) {
  return madeRequest('POST', {
    data: adData,
    url: replaceRouteParams(ENDPOINTS.assetGroups, {
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export async function getAssetGroupsService(params: object, platform: string) {
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.assetGroups, {
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export async function getAssetGroupService({ id, ...params }: { id: string; [key: string]: any }, platform: string) {
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.assetGroup, {
      id,
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export async function updateAssetGroupService(data: object, id: string, platform: string) {
  return madeRequest('PATCH', {
    data,
    url: replaceRouteParams(ENDPOINTS.assetGroup, {
      id,
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export async function createAssetGroupSignalService(assetGroupSignalData: object, platform: string) {
  return madeRequest('POST', {
    data: assetGroupSignalData,
    url: replaceRouteParams(ENDPOINTS.assetGroupSignals, {
      platform: ENDPOINT_PLATFORM[platform]
    })
  })
}

export function approveInternalAssetGroupService(id: string) {
  return madeRequest('POST', {
    url: `${ENDPOINTS.internalAssetGroups}${id}/approve/`
  })
}

export function disapproveInternalAssetGroupService(id: string, data: object) {
  return madeRequest('POST', {
    data,
    url: `${ENDPOINTS.internalAssetGroups}${id}/disapprove/`
  })
}
